module.exports = __webpack_public_path__ + "60a1022285f1b3cb770dee48e153ad37.jpg";